import { useEffect, useState } from 'react'
import { Box, Grid } from '@mui/material'
import { BaseButtons, creaLabelNumeroEAnno, ElenchiManager, BaseContenutoConProgress, ICONE, BaseGridLayout, BaseScatola, BaseGrassetto, BaseIconaEContenuto, BaseTesto } from '@lucan/base-ui'
import { CATEGORIE_PERMESSO, creaLabelPrefisso, LabelTipologiaPermesso, RiassuntoTarghePermesso, RiassuntoValiditaPermesso } from '@lucan/base-ui-jconnet'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import ScatolaRisultatoRicerca from 'components/ui/ScatolaRisultatoRicerca'
import Sezione from 'components/ui/Sezione'
import BottoneIndietro from 'components/ui/BottoneIndietro'
import Testo from 'components/ui/Testo'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'
import useNavigate from 'utils/useNavigate'
import PassContenitore from '../PassContenitore'

export default function PassLista() {
  const { inviaOperazione } = useRichiestaServerLogged()

  return (
    <PassContenitore>
      <ElenchiManager
        elenchi={[
          ELENCHI.PASS_PREFISSI,
          ELENCHI.PASS_TIPOLOGIE,
        ]}
        render={el =>
          <PassListaInterna
            optionsPrefissi={el(ELENCHI.PASS_PREFISSI)}
            optionsTipologie={el(ELENCHI.PASS_TIPOLOGIE)}
          />
        }
        opzioniGetElenco={{ inviaOperazione }}
      />
    </PassContenitore>
  )
}



function PassListaInterna(props) {
  const [permessiLight, setPermessiLight] = useState(null)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  useEffect(() => {
    async function fetchPermessi() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.PASS_SEARCH)
      if (ok && data.esito) setPermessiLight(data.data.records)
    }
    fetchPermessi()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { navigate } = useNavigate()

  function tornaAllaHome() {
    navigate(CHIAVI_ROUTES.PASS)
  }

  return (
    <>
      {ScatolaMessaggi}

      <BottoneIndietro
        testo='Esci'
        onClick={tornaAllaHome}
      />

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        {permessiLight && (
          permessiLight.length > 0 ? (
            <Sezione>
              <BaseGridLayout vertical noWrap>
                {permessiLight.map(permessoLight =>
                  <ScatolaPermessoLight
                    permessoLight={permessoLight}
                    key={permessoLight.uuid}
                    {...props}
                  />
                )}
              </BaseGridLayout>
            </Sezione>
          ) : (
            <Testo>Nessun permesso trovato per la tua anagrafica.</Testo>
          )
        )}
      </BaseContenutoConProgress>
    </>
  )
}



function ScatolaPermessoLight(props) {
  const {
    permessoLight,
    optionsPrefissi,
    optionsTipologie,
    val,
    txt
  } = props

  const {
    uuid,
    anagrafica,
    prefissoId,
    numero,
    anno,
    dataInizio,
    dataFine,
    validitaCalcolata,
    tipologiaId,
    usaTipologia,
    targhe,
    targheTutte,
    permessoBase: { categoria }
  } = permessoLight

  const { navigate } = useNavigate()

  function vaiAlPermesso() {
    navigate(CHIAVI_ROUTES.PASS_DETTAGLI, { uuid })
  }

  return (
    <BaseScatola>
      <ScatolaRisultatoRicerca
        Icona={ICONE.DESCRIZIONE}
        titolo={`Permesso ${creaLabelPrefisso(prefissoId, optionsPrefissi)} ${creaLabelNumeroEAnno(numero, anno)}`}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={5} lg={4}>
            <BaseIconaEContenuto
              dimensioneIcona='media'
              icona={anagrafica.azienda ? <ICONE.AZIENDA /> : <ICONE.PERSONA />}
            >
              <BaseGrassetto>{anagrafica.denominazione}</BaseGrassetto>
              <BaseTesto piccolo>{anagrafica.cfPiva}</BaseTesto>
            </BaseIconaEContenuto>
          </Grid>

          <Grid item xs={12} sm={4} lg={4}>
            <Box sx={{ mb: 0.5 }}>
              Tipologia:&nbsp;
              <LabelTipologiaPermesso
                tipologiaId={tipologiaId}
                optionsTipologie={optionsTipologie}
                usaTipologia={usaTipologia}
                visioneRiassuntiva
              />
            </Box>
            <RiassuntoValiditaPermesso
              dataInizio={dataInizio}
              dataFine={dataFine}
              validitaCalcolata={validitaCalcolata}
              mostraDescrValidita
            />
          </Grid>

          <Grid item xs={12} sm={3} lg={2}>
            {categoria === CATEGORIE_PERMESSO.SLOT_GIORNALIERI ? (
              <BaseGrassetto>Calendario targhe</BaseGrassetto>
            ) : (
              <RiassuntoTarghePermesso
                targhe={targhe} targheTutte={targheTutte}
                soloTarga numeroMassimoDaMostrare={3}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={12} lg={2}>
            <BaseButtons.Dettagli
              testo='Dettagli'
              onClick={vaiAlPermesso}
            />
          </Grid>
        </Grid>
      </ScatolaRisultatoRicerca>
    </BaseScatola>
  )
}